export default __webpack_public_path__ + "static/media/vendorProfile.f025dbb9.png";